/**
 * Age at the cycle's closing date.
 *
 * Mirrors `ageOn` on the server. Eligibility is measured at the close, not the
 * application date, so someone who turns 18 during the round qualifies — and
 * the picker must agree with what submit will decide.
 */
export function ageOnClose(dateOfBirth: string, closesAt: string | null): number {
  const on = closesAt ? new Date(closesAt) : new Date();
  const dob = new Date(`${dateOfBirth}T00:00:00Z`);
  let age = on.getUTCFullYear() - dob.getUTCFullYear();
  const monthDelta = on.getUTCMonth() - dob.getUTCMonth();
  if (monthDelta < 0 || (monthDelta === 0 && on.getUTCDate() < dob.getUTCDate())) {
    age -= 1;
  }
  return age;
}
